import { useOrgCustomization } from "@app/screens/Settings/General/data";
import { useEffect } from "react";

export type EventType = {
    type: string;
    message: string;
    isDone: boolean;
};

export function useSSE(path: string, onEvent?: (event: EventType) => void) {
    const { data } = useOrgCustomization();
    const tenantId = data?.org?.tenantId || "";

    useEffect(() => {
        if (!tenantId) {
            return;
        }

        const baseUrl = import.meta.env.VITE_REACT_APP_REST_URL;
        if (!baseUrl) {
            throw new Error("VITE_REACT_APP_REST_URL is not defined.");
        }

        const url = new URL(`sse/stream/${tenantId}/${path}`, baseUrl);
        const source = new EventSource(url);

        source.onmessage = (event) => {
            try {
                const parsed: EventType = JSON.parse(event.data);
                onEvent?.(parsed);
            } catch (error) {
                console.error("Error parsing event", error);
            }
        };

        source.onerror = (err) => {
            console.error("SSE error", err);
            source.close();
        };

        return () => {
            source.close();
        };
    }, [path, tenantId]);
}
